// utils/classroomHelpers.js
import http from "../api/apiClient";
import config from "../config";

/**
 * Classroom details
 */
export async function fetchClassroomData(id, token) {
  const res = await http.get(`${config.apiBaseUrl}/classrooms/${id}`);
  return res.data;
}

/**
 * Kinderen in klas
 */
export async function fetchClassroomChildren(id, token) {
  const res = await http.get(`${config.apiBaseUrl}/classrooms/${id}/children`);
  return res.data;
}

/**
 * Actieve teacher-assignments voor klas
 * Gebruik de route die je eerder had; als jouw backend query-params gebruikt,
 * vervang dan door: /teacher-classrooms?classroomId=...&active=true
 */
export async function fetchTeachersByClassroom(classroomId, token) {
  const res = await http.get(
    `${config.apiBaseUrl}/teacher-classrooms/classroom/${classroomId}`
  );
  return res.data || [];
}

/**
 * Historische teacher-assignments voor klas
 * Idem: pas aan naar query-params als jouw backend dat verwacht.
 */
export async function fetchTeacherHistoryByClassroom(classroomId, token) {
  const res = await http.get(
    `${config.apiBaseUrl}/teacher-classrooms/classroom/${classroomId}/history`
  );
  return res.data || [];
}

/**
 * Kind loskoppelen van klas
 */
export async function unassignChildFromClassroom(childId, classroomId, token) {
  const res = await http.post(
    `${config.apiBaseUrl}/child-classrooms/unassign`,
    null,
    { params: { childId, classroomId } }
  );
  return res.data;
}

/**
 * Klas van kind als 'current' instellen
 */
export async function setCurrentClassroom(childId, classroomId, token) {
  const res = await http.post(
    `${config.apiBaseUrl}/child-classrooms/set-current`,
    null,
    { params: { childId, classroomId } }
  );
  return res.data;
}

/**
 * Alle klassen
 */
export const fetchAvailableClassrooms = async (token) => {
  const res = await http.get(`${config.apiBaseUrl}/classrooms`);
  return res.data || [];
};